import { Image } from "tamagui";
import { type ViewProps, XStack } from "./Stacks";
export type BackgroundRadialGrantedGradientProps = ViewProps & {
  fullscreen?: boolean;
  objectFit?: "cover" | "fill";
};
export const BackgroundRadialGrantedGradient = (props: BackgroundRadialGrantedGradientProps) => {
  const {
    fullscreen = true,
    objectFit = "cover",
    ...rest
  } = props;
  return <XStack top={0} left={0} right={0} position="absolute" width="100%" height="100%" overflow="hidden" zIndex={0} backgroundColor={fullscreen ? "$surface1" : undefined} {...rest} data-sentry-element="XStack" data-sentry-component="BackgroundRadialGrantedGradient" data-sentry-source-file="BackgroundRadialGrantedGradient.tsx">
      <Image src={fullscreen ? "/static/backgroundGradientFullscreen.png" : "/static/backgroundGradient.png"} height={fullscreen ? "auto" : "100%"} width="100%" maxWidth={fullscreen ? 1200 : undefined} objectFit={fullscreen && objectFit === "cover" ? "contain" : objectFit} style={{
      opacity: 1,
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: fullscreen ? undefined : 0,
      marginLeft: fullscreen ? "auto" : undefined,
      marginRight: fullscreen ? "auto" : undefined
    }} data-sentry-element="Image" data-sentry-source-file="BackgroundRadialGrantedGradient.tsx" />
    </XStack>;
};